<template>
  <Modal :open="open" @close="$emit('close')">
    <div class="text-center mb-6">
      <h2 class="text-2xl font-bold text-gray-900">Configurer le système de primes</h2>
    </div>

    <div class="space-y-4 text-gray-700">
      <div class="flex items-start space-x-3">
        <span class="text-2xl">🏆</span>
        <p class="text-base">
          Motivez vos équipes en leur rétribuant une
          <span class="font-bold">partie de votre rémunération</span>
          sur chaque vente.
        </p>
      </div>

      <div class="flex items-start space-x-3">
        <span class="text-2xl">⚙️</span>
        <p class="text-base">
          Choisissez entre un
          <span class="font-bold">pourcentage de votre rémunération</span>
          ou un
          <span class="font-bold">montant fixe par offre</span>
          — vous pouvez configurer les deux séparément pour vos vendeurs et vos managers / directeurs.
        </p>
      </div>

      <div class="flex items-start space-x-3">
        <span class="text-2xl">📊</span>
        <p class="text-base">
          Une fois configurées, les montants des primes sont disponibles dans l'onglet
          <span class="font-bold">Suivi des primes.</span>
        </p>
      </div>
    </div>

    <div class="mt-8 flex justify-end">
      <SecondaryButton @click="$emit('close')">J'ai compris 😊</SecondaryButton>
    </div>
  </Modal>
</template>

<script>
import { Modal, SecondaryButton } from "@estaly/ui";

export default {
  name: "RetributionConfigurationsInfoModal",

  components: {
    Modal,
    SecondaryButton,
  },

  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },

  emits: ["close"],
};
</script>
